
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/run-for-me",
      function () {
        return require("private-next-pages/run-for-me.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/run-for-me"])
      });
    }
  